import { supabase } from '@/integrations/supabase/client';
import { resolveValorHoraAposRegra } from '@/utils/analises/aplicarRegrasDesmembramento';
import { aplicarRegrasDesmembramento, type AplicarRegrasDesmembramentoOpcoes } from './clienteSubdivisao';

export interface ClientProcessingResult {
  clienteFinal: string;
  empresaIdFinal: number | string;
  /** Quando desmembramento aplicou: valor/hora da regra ou do histórico do filho; senão null. */
  valorHoraRegra: number | null;
}

export const processClientWithSubdivision = async (
  apiData: any,
  cliente: string,
  produto: string,
  tipoProjeto: string,
  horasExecutadas: number,
  numero: string,
  opcoes?: AplicarRegrasDesmembramentoOpcoes,
  /** Data da OS (YYYY-MM-DD) para valor/hora vigente do histórico quando a regra não define valor. */
  dataAberturaYmd?: string | null
): Promise<ClientProcessingResult> => {
  let clienteFinal = cliente;
  let empresaIdFinal: number | string = apiData.empresa_id;
  let valorHoraRegra: number | null = null;

  console.log(`=== OS ${numero} - DADOS PARA DESMEMBRAMENTO ===`);
  console.log(`Cliente: "${cliente}"`);
  console.log(`PRODUTO: "${produto}" ${produto && produto !== 'Produto não informado' ? '✅ VÁLIDO' : '❌ INVÁLIDO'}`);
  console.log(`Tipo projeto: "${tipoProjeto}"`);
  console.log(`Horas executadas: ${horasExecutadas}`);

  // Apply subdivision rules if we have the required data
  if (apiData.empresa_id && produto && produto !== 'Produto não informado') {
    console.log(`=== OS ${numero} - APLICANDO REGRAS DE DESMEMBRAMENTO ===`);
    console.log(`🏷️ USANDO PRODUTO: "${produto}"`);
    
    // Normalize product for rule application
    const produtoNormalizado = produto.toUpperCase().replace(/\s+/g, '_');
    console.log(`Produto normalizado: "${produtoNormalizado}"`);
    
    const desmembramentoResult = await aplicarRegrasDesmembramento(
      apiData.empresa_id,
      apiData.operador_id,
      produtoNormalizado,
      tipoProjeto === 'Sim' ? 'FECHADO' : 'ABERTO',
      horasExecutadas,
      numero,
      opcoes
    );

    if (desmembramentoResult.clienteRedirecionado) {
      console.log(`🔄 OS ${numero} - Cliente redirecionado de ${apiData.empresa_id} para ${desmembramentoResult.clienteRedirecionado}`);
      console.log(`📋 Justificativa: ${desmembramentoResult.justificativa}`);
      empresaIdFinal = desmembramentoResult.clienteRedirecionado;
      const { data: cad } = await supabase
        .from('clientes_cadastro')
        .select('nome')
        .eq('empresa_id', desmembramentoResult.clienteRedirecionado)
        .maybeSingle();
      if (cad?.nome?.trim()) {
        clienteFinal = cad.nome.trim();
      } else if (desmembramentoResult.regraAplicada?.cliente_filho_nome?.trim()) {
        clienteFinal = desmembramentoResult.regraAplicada.cliente_filho_nome.trim();
      }
      if (desmembramentoResult.regraAplicada) {
        const dataOS =
          (dataAberturaYmd && /^\d{4}-\d{2}-\d{2}$/.test(dataAberturaYmd) && dataAberturaYmd) ||
          String((apiData as { data?: { real?: string } })?.data?.real || '').slice(0, 10) ||
          new Date().toISOString().split('T')[0];
        valorHoraRegra = await resolveValorHoraAposRegra(desmembramentoResult.regraAplicada, dataOS);
      }
    } else {
      console.log(`ℹ️ OS ${numero} - Nenhuma regra aplicável para produto "${produto}"`);
    }
  } else if (!apiData.empresa_id) {
    console.log(`⚠️ OS ${numero} - Sem empresa_id, não aplicando desmembramento`);
  } else if (!produto || produto === 'Produto não informado') {
    console.error(`❌ OS ${numero} - PRODUTO AUSENTE, não aplicando desmembramento!`);
  }

  return { clienteFinal, empresaIdFinal, valorHoraRegra };
};
